import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devSearchSchemaFor } from "@/modules/dev/registry/previews";

export const Route = createFileRoute("/dev/join-loading")({
  validateSearch: devSearchSchemaFor("join-loading"),
  component: lazyRouteComponent(
    () => import("@/modules/coaching/join/dev/JoinLoadingPreview"),
    "JoinLoadingPreview",
  ),
});
